import Swal from 'sweetalert2';
import hook from '../../scripts/utilities/hook';

const TRIGGER_SELECTOR = hook('js-iframe-modal-trigger');

class IFRAME_MODAL {
  constructor(element) {
    // early exist
    if (!element) {
      return;
    }
    this.element = element;

    this.initSelectors();
    this.initListeners();
  }

  initSelectors() {
    this.dataSrc = this.element.dataset.iframeSrc;
  }

  initListeners() {
    this.element.addEventListener('click', () => {
      this.openModal();
    });
  }

  openModal() {
    Swal.fire({
      html: `<iframe
          class="c-iframe-modal"
          width="560"
          height="315"
          src="${this.dataSrc}"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen>
        </iframe>`,
      width: 'auto',
      showCloseButton: true,
      showConfirmButton: false,
      focusConfirm: false,
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll(TRIGGER_SELECTOR).forEach(element => {
    // eslint-disable-next-line no-unused-vars
    const elementCard = new IFRAME_MODAL(element);
  });
});
